var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTollCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0015 15.5C11.9082 15.5 10.1346 14.7736 8.68075 13.3207C7.22692 11.8679 6.5 10.0948 6.5 8.0015C6.5 5.90817 7.22642 4.13458 8.67925 2.68075C10.1321 1.22692 11.9052 0.5 13.9985 0.5C16.0918 0.5 17.8654 1.22642 19.3193 2.67925C20.7731 4.13208 21.5 5.90517 21.5 7.9985C21.5 10.0918 20.7736 11.8654 19.3208 13.3193C17.8679 14.7731 16.0948 15.5 14.0015 15.5ZM6 15.2308C4.3615 14.7961 3.03525 13.9086 2.02125 12.5683C1.00708 11.2279 0.5 9.70517 0.5 8C0.5 6.29483 1.00708 4.77208 2.02125 3.43175C3.03525 2.09142 4.3615 1.20392 6 0.76925V2.35C4.8 2.76667 3.83333 3.49167 3.1 4.525C2.36667 5.55833 2 6.71667 2 8C2 9.28333 2.36667 10.4417 3.1 11.475C3.83333 12.5083 4.8 13.2333 6 13.65V15.2308ZM14 14C15.6667 14 17.0833 13.4167 18.25 12.25C19.4167 11.0833 20 9.66667 20 8C20 6.33333 19.4167 4.91667 18.25 3.75C17.0833 2.58333 15.6667 2 14 2C12.3333 2 10.9167 2.58333 9.75 3.75C8.58333 4.91667 8 6.33333 8 8C8 9.66667 8.58333 11.0833 9.75 12.25C10.9167 13.4167 12.3333 14 14 14Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTollCharge);
export default __webpack_public_path__ + "static/media/TollCharge.9adc13a594aee47dced4fb36be1f3769.svg";
export { ForwardRef as ReactComponent };